import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/header/Header";
import Edit from "../components/products/Edit";

const ProductPage = () => {
  const { t } = useTranslation("pages");
  return (
    <>
      <Header />
      <div className="px-6">
        <h1 className="text-2xl font-semibold text-center mb-4 text-gray-800">{t("products")}</h1>
        <Edit />
      </div>
    </>
  );
};

export default ProductPage;
